import { render, staticRenderFns } from "./CreateMultipleAssignments.vue?vue&type=template&id=6626c90c"
import script from "./CreateMultipleAssignments.js?vue&type=script&lang=js&external"
export * from "./CreateMultipleAssignments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports